export const favorites = ['Overview', 'Projects'];
import {
  ArrowRightLeft,
  BookOpen,
  ChartPie,
  Coins,
  FlaskConical,
  FolderClosed,
  Home,
  LucideProps,
  ShoppingBag,
  TrendingUp,
  UserCog,
  Users,
  Vault,
} from 'lucide-react';

export const mainNavigationList: TNavItem[] = [
  {
    icon: ChartPie,
    label: 'Overview',
    path: '/',
    defaultOpen: false,
    subItems: [],
  },
  {
    icon: UserCog,
    label: 'Admins',
    path: '/admins',
    defaultOpen: false,
    subItems: [],
  },
  {
    icon: ShoppingBag,
    label: 'eCommerce',
    path: '/ecommerce',
    defaultOpen: false,
    subItems: [
      { label: 'Products', path: '/ecommerce/products' },
      { label: 'Sales', path: '/ecommerce/sales' },
      { label: 'Expense', path: '/ecommerce/expense' },
    ],
  },
  {
    icon: FolderClosed,
    label: 'NFTS',
    path: '/nfts',
    defaultOpen: false,
    subItems: [
      { label: 'In Progress', path: '/nfts/in-progress' },
      { label: 'Completed', path: '/nfts/completed' },
      { label: 'Pending', path: '/nfts/pending' },
      { label: 'Collaborators', path: '/nfts/collaborators' },
    ],
  },
  {
    icon: BookOpen,
    label: 'Educational',
    path: '/educational',
    defaultOpen: false,
    subItems: [
      { label: 'All', path: '/educational/all' },
      { label: 'Featured', path: '/educational/featured' },
      { label: 'Categories', path: '/educational/categories' },
      { label: 'My Courses', path: '/educational/my-courses' },
    ],
  },
];

export const secondaryNavigationList: TSecondaryNavList[] = [
  {
    label: 'Inventory',
    path: '/inventory',
    defaultOpen: true,
    subItems: [
      { label: 'Overview', path: '/product/overview' },
      { label: 'Projects', path: '/product/projects' },
      { label: 'Campaigns', path: '/product/campaigns' },
      { label: 'Documents', path: '/product/documents' },
      { label: 'Followers', path: '/product/followers' },
    ],
  },
  {
    label: 'NFT Management',
    path: '/nft-management',
    defaultOpen: false,
    subItems: [
      { label: 'Overview', path: '/nft-management/overview' },
      { label: 'Collections', path: '/nft-management/collections' },
      { label: 'Minting', path: '/nft-management/minting' },
      { label: 'Transfers', path: '/nft-management/transfers' },
      { label: 'Activity', path: '/nft-management/activity' },
    ],
  },
  {
    label: 'User Management',
    path: '/user-management',
    defaultOpen: false,
    subItems: [
      { label: 'Users', path: '/user-management/users' },
      { label: 'Roles', path: '/user-management/roles' },
      { label: 'Permissions', path: '/user-management/permissions' },
      { label: 'Teams', path: '/user-management/teams' },
    ],
  },
  {
    label: 'Community',
    path: '/community',
    defaultOpen: false,
    subItems: [
      { label: 'Discussions', path: '/community/discussions' },
      { label: 'Spotlight', path: '/community/spotlight' },
      { label: 'Events', path: '/community/events' },
      { label: 'Groups', path: '/community/groups' },
    ],
  },
  {
    label: 'Order/Transaction',
    path: '/order-transaction',
    defaultOpen: false,
    subItems: [
      { label: 'Order History', path: '/order-transaction/order-history' },
      { label: 'Transactions', path: '/order-transaction/transactions' },
      { label: 'Invoices', path: '/order-transaction/invoices' },
      { label: 'Refunds', path: '/order-transaction/refunds' },
    ],
  },
  {
    label: 'Site Content',
    path: '/site-content',
    defaultOpen: false,
    subItems: [
      { label: 'Blog Posts', path: '/site-content/blog-posts' },
      { label: 'News', path: '/site-content/news' },
      { label: 'FAQs', path: '/site-content/faqs' },
      { label: 'Media', path: '/site-content/media' },
    ],
  },
];

interface SideBarItem {
  icon: React.ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
  >;
  label: string;
  path: string;
}

interface SideBarItemList {
  [key: string]: SideBarItem[];
}

export const SideBarItemList: SideBarItemList = {
  'MAIN MENU': [
    {
      icon: Home,
      label: 'Dashboard',
      path: '/',
    },
    // {
    //   icon: FileText,
    //   label: 'Transaction',
    //   path: '/transaction',
    // },
  ],
  PRODUCTS: [
    // {
    //   icon: CirclePlus,
    //   label: 'Add Products',
    //   path: '/add-product',
    // },
    // {
    //   icon: Package,
    //   label: 'Product List',
    //   path: '/products',
    // },
    // {
    //   icon: Box,
    //   label: 'NFT',
    //   path: '/nfts',
    // },
    {
      icon: Coins,
      label: 'Assets',
      path: '/assets',
    },
    // {
    //   icon: FolderClosed,
    //   label: 'Product Categories',
    //   path: '/product-categories',
    // },
  ],
  ADMIN: [
    {
      icon: Users,
      label: 'Customers',
      path: '/admin/customers',
    },
    {
      icon: TrendingUp,
      label: 'Investments',
      path: '/admin/investments',
    },
    {
      icon: Vault,
      label: 'Wallet Ops',
      path: '/wallet-ops',
    },
    {
      icon: ArrowRightLeft,
      label: 'Asset Transfer',
      path: '/asset-transfer',
    },
    {
      icon: FlaskConical,
      label: 'Testing',
      path: '/testing',
    },
    {
      icon: BookOpen,
      label: 'Knowledge Base',
      path: '/knowledge-base',
    },
    // {
    //   icon: FileText,
    //   label: 'Site Pages',
    //   path: '/site-pages',
    // },
    // {
    //   icon: Settings,
    //   label: 'Admin Pages',
    //   path: '/admins',
    // },
    // {
    //   icon:Settings,
    //   label: "Press Release",
    //   path: "/press-and-media"
    // },
    //     {
    //   icon:ListCheck,
    //   label: "Order list",
    //   path: "/orders"
    // },
    //   {
    //   icon:HelpCircle,
    //   label: "Support Tickets",
    //   path: "/support-tickets"
    // }
  ],
};

export type TSecondaryNavList = {
  label: string;
  path: string;
  defaultOpen: boolean;
  subItems: { label: string; path: string }[];
};

export type TNavItem = {
  icon: React.ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
  >;
  label: string;
  path: string;
  defaultOpen: boolean;
  subItems: { label: string; path: string }[];
};
